// 对所有JSBridge方法做统一整理，避免重复需求出现多个相同作用方法

import { callhandler, registerHandler } from "./jsBridge";

// 1. 注册事件，客户端调用h5页面
/* ------ 获取账号信息 ------ */
export const signInEventTrack = cb => registerHandler("signInEventTrack", cb); // 初始化数据
export const phoneBackButtonListener = cb => registerHandler("phoneBackButtonListener", cb); // 系统返回键事件
export const getUserInfo = cb => registerHandler("getUserInfo", cb); // 用户信息
export const clickRightTxt = cb => registerHandler("clickRightTxt", cb); //  无需回传字段
export const isOpenNotification = cb => registerHandler("isOpenNotification", cb); // 获取消息通知权限状态
export const loginSuccess = cb => registerHandler("loginSuccess", cb); // 登录成功通知


/* ------------------------------- */

// 2. 直接调用客户端事件
/* --------- 调用APP事件 ---------- */
// 返回键
export const onGoBack = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("onGoBack", ...args);
}

// 关闭当前页面
export const onClosePage = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("onClosePage", ...args);
}

// 拉起登录
export const toLogin = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("toLogin", ...args);
}

export const setPageTitle = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("setPageTitle", ...args);
}

export const setPageTitleColor = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("setPageTitleColor", ...args);
}

export const setRightTxtColor = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("setRightTxtColor", ...args);
}

export const setPageTitleBgColor = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("setPageTitleBgColor", ...args);
}

export const setRightTxt = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("setRightTxt", ...args);
}

// 跳转原生页面
export const jumpToNative = async (data) => {
  const args = await handleArguments(data);
  callhandler("jumpToNative", ...args);
}

// 使用外部浏览器跳转页面
export const jumpToExternal = async (data) => {
  const args = await handleArguments(data);
  callhandler("jumpToNativeBrowser", ...args);
}

// 新 webview 容器打开页面
export const jumpToNewWeb = async (data) => {
  const args = await handleArguments(data);
  callhandler("jumpToNewWeb", ...args);
}

// 打开消息通知权限
export const openNotification = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("openNotification", ...args);
}

/**
 * h5页面通知客户端当前数据加载状态
 * @param {*}  
 * @returns 
 */
export const dataLoadFinished = async (data) => {
  const args = await handleArguments(data);
  callhandler("dataLoadFinished", ...args);
}

/**
 * h5页面通知客户端当前活动页不需要顶部标题栏
 * @param {*}  
 * @returns 
 */
export const callHideToolbar = async (data) => {
  const args = await handleArguments(data);
  callhandler("IsHideToolbar", ...args);
}

/**
 * h5页面询问客户端本地是否安装某些包
 * @param {*} pkg[] 包名数组
 * @returns pkg[] 已安装的包名数组
 */
export const isInstalledPackage = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("isInstalledPackage", ...args);
}

/**
 * 跳转系统浏览器打开指定页面
 * @param {*} url
 */
export const turnToSystemWeb = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("turnToSystemWeb", ...args);
}

// 通知客户端账号注销成功
export const notifyAccountClosed = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("notifyAccountClosed", ...args);
}

// 通知安卓侧触发数据埋点
export const onAnalyticsTrackEvent = async (data, cb) => {
  const args = await handleArguments(data, cb);
  callhandler("onAnalyticsTrackEvent", ...args);
}

// export const phoneBackButtonListener = async (data) => {
//   const args = await handleArguments(data);
//   callhandler("phoneBackButtonListener", ...args);
// }

/* ------------------------------- */

const handleArguments = function (data, cb) {
  if (typeof data === "function" && !cb) {
    cb = data;
    data = null;
  }
  return [data, cb];
};
